module.exports = __webpack_public_path__ + "static/media/image5.199ddea8.jpg";